export const words = {
  m3: {
    // Drive - Positive
    commanding: 'Comandante', decisive: 'Decisivo', dominant: 'Dominante', assertive: 'Asertivo',
    bold: 'Audaz', direct: 'Directo', ambitious: 'Ambicioso', influential: 'Influyente', proactive: 'Proactivo',
    // Drive - Negative
    accommodating: 'Complaciente', cooperative: 'Cooperativo', agreeable: 'Agradable', supportive: 'Solidario',
    humble: 'Humilde', diplomatic: 'Diplomático', collaborative: 'Colaborativo', gentle: 'Gentil', modest: 'Modesto',
    // Connection - Positive
    sociable: 'Sociable', expressive: 'Expresivo', outgoing: 'Extrovertido', enthusiastic: 'Entusiasta',
    friendly: 'Amigable', warm: 'Cálido', engaging: 'Atractivo', charismatic: 'Carismático', animated: 'Animado',
    // Connection - Negative
    reserved: 'Reservado', private: 'Privado', quiet: 'Callado', reflective: 'Reflexivo',
    solitary: 'Solitario', introverted: 'Introvertido', contemplative: 'Contemplativo', observing: 'Observador', introspective: 'Introspectivo',
    // Task - Positive
    steady: 'Constante', patient: 'Paciente', consistent: 'Consistente', calm: 'Calmado',
    methodical: 'Metódico', reliable: 'Confiable', stable: 'Estable', composed: 'Compuesto', deliberate: 'Deliberado',
    // Task - Negative
    urgent: 'Urgente', fastPaced: 'Ritmo rápido', dynamic: 'Dinámico', impetuous: 'Impetuoso',
    restless: 'Inquieto', quick: 'Rápido', hasty: 'Precipitado', impulsive: 'Impulsivo', impatient: 'Impaciente',
    // Order - Positive
    systematic: 'Sistemático', organized: 'Organizado', structured: 'Estructurado', precise: 'Preciso',
    meticulous: 'Meticuloso', detailed: 'Detallista', accurate: 'Exacto', disciplined: 'Disciplinado', thorough: 'Minucioso',
    // Order - Negative
    informal: 'Informal', casual: 'Casual', creative: 'Creativo', relaxed: 'Relajado',
    easygoing: 'Despreocupado', versatile: 'Versátil', flexible: 'Flexible', unconventional: 'No convencional', unplanned: 'Improvisado',
    // Style - Positive
    analytical: 'Analítico', logical: 'Lógico', dataDriven: 'Orientado a datos', rational: 'Racional',
    objective: 'Objetivo', factual: 'Factual', reasoned: 'Razonado', critical: 'Crítico', skeptical: 'Escéptico',
    // Style - Negative
    intuitive: 'Intuitivo', feelingOriented: 'Orientado a sentimientos', emotional: 'Emocional',
    instinctive: 'Instintivo', empathetic: 'Empático', imaginative: 'Imaginativo',
    compassionate: 'Compasivo', heartfelt: 'Sincero', sentimental: 'Sentimental',
  },
  m2: {
    // Drive (15 words)
    authoritative: 'Autoritario',
    commanding: 'Comandante',
    forceful: 'Enérgico',
    influential: 'Influyente',
    decisive: 'Decisivo',
    assertive: 'Asertivo',
    direct: 'Directo',
    firm: 'Firme',
    strongWilled: 'Decidido',
    confident: 'Confiado',
    ambitious: 'Ambicioso',
    proactive: 'Proactivo',
    independent: 'Independiente',
    selfAssured: 'Seguro de sí mismo',
    goalOriented: 'Orientado a objetivos',
    
    // Connection (15 words)
    expressive: 'Expresivo',
    sociable: 'Sociable',
    enthusiastic: 'Entusiasta',
    vibrant: 'Vibrante',
    animated: 'Animado',
    friendly: 'Amigable',
    warm: 'Cálido',
    engaging: 'Cautivador',
    personable: 'Agradable',
    communicative: 'Comunicativo',
    approachable: 'Accesible',
    welcoming: 'Acogedor',
    interactive: 'Interactivo',
    affable: 'Afable',
    gregarious: 'Gregario',
    
    // Task (15 words)
    composed: 'Sereno',
    tranquil: 'Tranquilo',
    steady: 'Estable',
    unflappable: 'Imperturbable',
    poised: 'Equilibrado',
    gentle: 'Gentil',
    balanced: 'Balanceado',
    evenTempered: 'Ecuánime',
    accommodating: 'Complaciente',
    flexible: 'Flexible',
    thoughtful: 'Reflexivo',
    considerate: 'Considerado',
    understanding: 'Comprensivo',
    peaceful: 'Pacífico',
    supportive: 'Solidario',
    
    // Order (15 words)
    organized: 'Organizado',
    systematic: 'Sistemático',
    structured: 'Estructurado',
    methodical: 'Metódico',
    rigorous: 'Riguroso',
    procedural: 'Procesal',
    detailed: 'Detallista',
    thorough: 'Minucioso',
    careful: 'Cuidadoso',
    precise: 'Preciso',
    professional: 'Profesional',
    proper: 'Correcto',
    conventional: 'Convencional',
    traditional: 'Tradicional',
    orderly: 'Ordenado',
    
    // Style (15 words)
    dataDriven: 'Orientado por datos',
    reasoned: 'Razonado',
    impartial: 'Imparcial',
    evidenceBased: 'Basado en evidencia',
    cerebral: 'Cerebral',
    calculated: 'Calculador',
    rationalMinded: 'Mente racional',
    factFocused: 'Enfocado en hechos',
    measured: 'Mesurado',
    reflective: 'Reflexivo',
    perceptive: 'Perceptivo',
    feelingOriented: 'Orientado por sentimientos',
    passionate: 'Apasionado',
    instinctive: 'Instintivo',
    sentimental: 'Sentimental'
  },
  behavioral: {
    dominant: 'Dominante',
    bold: 'Audaz',
    assertive: 'Asertivo',
    commanding: 'Comandante',
    powerful: 'Poderoso',
    courageous: 'Valiente',
    daring: 'Atrevido',
    determined: 'Determinado',
    competitive: 'Competitivo',
    resolute: 'Resuelto',
    formidable: 'Formidable',
    eager: 'Entusiasmado',
    relentless: 'Implacable',
    outstanding: 'Destacado',
    dignified: 'Digno',
    social: 'Social',
    engaging: 'Comprometido',
    charismatic: 'Carismático',
    convincing: 'Convincente',
    popular: 'Popular',
    sympathetic: 'Simpático',
    charming: 'Encantador',
    pleasant: 'Ameno',
    talkative: 'Hablador',
    esteemed: 'Estimado',
    exciting: 'Emocionante',
    lively: 'Animado',
    appealing: 'Atractivo',
    outgoing: 'Extrovertido',
    communicative: 'Comunicativo',
    patient: 'Paciente',
    reasonable: 'Razonable',
    content: 'Satisfecho',
    persistent: 'Persistente',
    relaxed: 'Relajado',
    serene: 'Sereno',
    tolerant: 'Tolerante',
    consistent: 'Consistente',
    calm: 'Tranquilo',
    agreeable: 'Agradable',
    stable: 'Estable',
    respectful: 'Respetuoso',
    unobtrusive: 'Discreto',
    easyGoing: 'Despreocupado',
    harmonious: 'Armonioso',
    neat: 'Ordenado',
    understanding: 'Comprensivo',
    contemplative: 'Contemplativo',
    conventional: 'Convencional',
    polished: 'Refinado',
    formal: 'Formal',
    precise: 'Preciso',
    accurate: 'Exacto',
    factual: 'Factual',
    disciplined: 'Disciplinado',
    orderly: 'Ordenado',
    principled: 'Con principios',
    observant: 'Observador',
    meticulous: 'Meticuloso',
    objective: 'Objetivo',
    analytical: 'Analítico',
    logical: 'Lógico',
    systematic: 'Sistemático',
    rational: 'Racional',
    methodical: 'Metódico',
    detached: 'Desapegado',
    realistic: 'Realista',
    pragmatic: 'Pragmático',
    critical: 'Crítico',
    empirical: 'Empírico',
    emotional: 'Emocional',
    intuitive: 'Intuitivo',
    impulsive: 'Impulsivo',
    anxious: 'Ansioso',
    spontaneous: 'Espontáneo',
    // Additional Model 1 words
    cooperative: 'Cooperativo',
    cheerful: 'Alegre',
    generous: 'Generoso',
    passive: 'Pasivo',
    quiet: 'Tranquilo',
    modest: 'Modesto',
    laidBack: 'Relajado',
    reliable: 'Confiable',
    evenPaced: 'De ritmo constante',
    gracious: 'Cortés',
    reserved: 'Reservado',
    lenient: 'Indulgente',
    perfectionist: 'Perfeccionista',
    tactful: 'Diplomático',
    cautious: 'Cauteloso',
    conscientious: 'Escrupuloso',
    diligent: 'Diligente',
    conservative: 'Conservador',
    compliant: 'Obediente',
    thorough: 'Minucioso',
    detailed: 'Detallista',
    careful: 'Cuidadoso',
    organized: 'Organizado',
    dataDriven: 'Orientado por datos',
    evidenceBased: 'Basado en evidencia',
    rationalMinded: 'Mente racional',
    factFocused: 'Enfocado en hechos',
    feelingOriented: 'Orientado por sentimientos',
    sentimental: 'Sentimental',
    perceptive: 'Perceptivo',
    reflective: 'Reflexivo',
    calculated: 'Calculador',
    cerebral: 'Cerebral',
    reasoned: 'Razonado',
    impartial: 'Imparcial',
    measured: 'Mesurado',
    passionate: 'Apasionado',
    instinctive: 'Instintivo',
    accommodating: 'Complaciente',
    sociable: 'Sociable',
    friendly: 'Amigable',
    balanced: 'Equilibrado'
  }
};
